import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * What a center reads about itself: the affiliation certificates it has been
 * issued, and the queries the council has passed to it.
 *
 * The enquiry itself is never written back - the only thing a center adds is
 * what came of the enquiry, which lives on the assignment rather than on the
 * enquiry, so two centers given the same enquiry answer separately.
 */

const token = () => localStorage.getItem("centerToken");

/** Every affiliation certificate this center holds, newest first. */
export const getMyCertificates = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("center/certificates", token()));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

/**
 * Queries the council has assigned to this center.
 * per_page is used by the download, which wants the lot in one go.
 */
export const getAssignedQueries = (params = {}) => async (dispatch) => {
  try {
    const q = new URLSearchParams();
    ["source", "search", "page", "per_page"].forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== "") q.append(key, value);
    });
    const suffix = q.toString() ? `?${q.toString()}` : "";

    const response = await dispatch(
      getDataAPI(`center/assigned-queries${suffix}`, token())
    );
    return response.data;
  } catch (error) {
    return false;
  }
};

/**
 * What came of one assigned query.
 * outcome: "admitted" with a date, "not_admitted" with a reason, or "" to
 * clear an answer given by mistake.
 */
export const saveQueryOutcome = (body) => async (dispatch) => {
  try {
    const form = new FormData();
    Object.keys(body).forEach((key) => form.append(key, body[key] ?? ""));

    const response = await dispatch(
      postDataAPI("center/assigned-queries/outcome", form, token())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be saved.");
    return false;
  }
};
